import Sidebar from "@/components/Sidebar";
import { Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import InstallPrompt from "@/components/InstallPrompt";

export default function Layout() {
  return (
    <div className="flex min-h-screen bg-[#F8F9FA]">
      <Sidebar />
      <main className="flex-1 min-w-0">
        {/* Mobile-only spacer: pushes content below the fixed 3.5rem topbar (+notch) */}
        <div
          className="md:hidden"
          style={{ height: "calc(3.5rem + env(safe-area-inset-top, 0px))" }}
          aria-hidden="true"
        />
        <Outlet />
      </main>
      <Toaster richColors position="top-right" />
      <InstallPrompt />
    </div>
  );
}
